import { FC } from "react";

import { PreferencePrivacyTypeEnum } from "~/constants";

import { RadioGroup, RadioGroupProps } from "../RadioGroup";

export interface PrivacyTypeRadioProps
  extends Omit<RadioGroupProps, "name" | "title" | "options"> {}

export const PrivacyTypeRadio: FC<PrivacyTypeRadioProps> = (props) => (
  <RadioGroup
    title="Character Privacy"
    name="privacyType"
    options={[
      {
        value: PreferencePrivacyTypeEnum.CAMPAIGN_ONLY,
        label: "Campaign Only",
        description:
          "Only others within a Campaign you have joined can view your Characters.",
      },
      {
        value: PreferencePrivacyTypeEnum.PUBLIC,
        label: "Public",
        description: "Anyone with a shared link can view your Characters.",
      },
      {
        value: PreferencePrivacyTypeEnum.PRIVATE,
        label: "Private",
        description: "Only you can view your Characters.",
      },
    ]}
    {...props}
  />
);
